"use strict";
//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Raw, css-injectable values for the Curalate theme variables.
 */
var variables = {
    colors: {
        white: '#fff',
        black: '#000',
        gray00: '#fafbfb',
        gray0: '#f5f6f6',
        gray1: '#e9eaec',
        gray2: '#dbdee0',
        gray3: '#cdd1d4',
        gray4: '#bec3c7',
        gray5: '#adb3b8',
        gray6: '#9ba0a5',
        gray7: '#868b8f',
        gray8: '#67686B',
        gray9: '#4E495C',
        orange0: '#fff4ea',
        orange1: '#ffe5c8',
        orange2: '#ffd5a7',
        orange3: '#ffc483',
        orange4: '#ffaf5a',
        orange5: '#ff9623',
        orange6: '#f68000',
        orange7: '#d76e00',
        orange8: '#af5800',
        orange9: '#763800',
        mint0: '#ebf8f6',
        mint1: '#c9f3ed',
        mint2: '#a7ebe1',
        mint3: '#81e2d2',
        mint4: '#51d7c3',
        mint5: '#00c9b1',
        mint6: '#00b59e',
        mint7: '#009e89',
        mint8: '#00806f',
        mint9: '#005549',
        cyan0: '#eff7f9',
        cyan1: '#d2f0f6',
        cyan2: '#b6e6f1',
        cyan3: '#97dbe9',
        cyan4: '#75cfe1',
        cyan5: '#47c1d7',
        cyan6: '#00b0c8',
        cyan7: '#0099b0',
        cyan8: '#007c92',
        cyan9: '#005363',
        red0: '#fff3f1',
        red1: '#ffdfd8',
        red2: '#ffcbc1',
        red3: '#ffb8aa',
        red4: '#ffa18f',
        red5: '#ff8670',
        red6: '#ff6248',
        red7: '#f84f35',
        red8: '#cc3b26',
        red9: '#8d1f11',
        yellow0: '#fff6d4',
        yellow1: '#ffe991',
        yellow2: '#ffd641',
        yellow3: '#ffc300',
        yellow4: '#eeaf00',
        yellow5: '#da9900',
        yellow6: '#c48100',
        yellow7: '#aa6700',
        yellow8: '#8a4b00',
        yellow9: '#5b2b00',
        green0: '#ebf9f2',
        green1: '#caf4df',
        green2: '#a8edcb',
        green3: '#82e4b5',
        green4: '#54d99c',
        green5: '#00cc7d',
        green6: '#00b76f',
        green7: '#009f5f',
        green8: '#00814b',
        green9: '#00562f',
        purple1: '#684B77',
        purple2: '#886C93',
        purple3: '#C4A3DC',
        teal1: '#007c92',
        teal2: '#0099b0',
        teal3: '#005f70',
        blue1: '#829edc',
        blue2: '#2f5ec4',
        blue3: '#1c3876',
    },
    spacings: {
        0: '0',
        1: '4px',
        2: '8px',
        3: '16px',
        4: '24px',
        5: '32px',
        6: '48px',
        7: '64px',
    },
    zindex: {
        popoverBackdrop: '990',
        fixed: '1030',
        sticky: '1030',
        modalBackdrop: '1040',
        modal: '1050',
        popover: '1060',
        tooltip: '1070',
        navbar: '1080',
    },
    gridColumns: '12',
    containerMaxWidths: {
        sm: '540px',
        md: '720px',
        lg: '960px',
        xl: '1140px',
    },
    gridBreakpoints: {
        xs: '0',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
    },
    fontWeights: {
        light: '300',
        normal: '400',
        semiBold: '600',
        bold: '700',
    },
    lineHeights: {
        titleLeading: '1.25',
        bodyLeading: '1.5',
        uiLeading: '1',
    },
    extraWideMeasure: '944px',
    wideMeasure: '584px',
    mediumMeasure: '440px',
    smallMeasure: '232px',
    fontSizes: {
        0: '48px',
        1: '32px',
        2: '24px',
        3: '20px',
        4: '16px',
        5: '14px',
        6: '12px',
        7: '10px',
    },
    borderRadii: {
        0: '0',
        1: '2px',
        2: '4px',
        3: '10px',
        4: '20px',
        pill: '500px',
    },
    borderWidths: {
        0: '0',
        1: '1px',
        1.5: '1.5px',
        2: '2px',
        3: '4px',
        4: '8px',
    },
    boxShadows: {
        0: 'none',
        1: '0 1px 3px 0 rgba(0, 0, 0, 0.24)',
        2: '0 3px 6px 0 rgba(0, 0, 0, 0.24)',
        3: '0 6px 6px 0 rgba(0, 0, 0, 0.24)',
        4: '0 10px 10px 0 rgba(0, 0, 0, 0.24)',
    },
};
exports.default = variables;
